import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import moment from 'moment'
import axios from 'axios'
import ProductDetails from './productDetails'

const Products = ({t, items, setProduct, scope}) => {

    if(items.length < 2) {
        return null
    }
    
    const [selected, setSelected] = useState(null)
	const queryScope = scope == 'query';

    const getItems = () => {
        return items.map((item) => {
            if(selected && item.id == selected.id){
                return (
                    <div key={item.id} className="widget_session_booking_product active" onClick={() => setProduct(item)}>
                        <div className="widget_session_booking_product_name">{item.name}</div>
                        <ProductDetails product={item} />
                    </div>
                )
            }
            return (
                <div key={item.id} className="widget_session_booking_product" onClick={() => setSelected(item)}>
                    <div className="widget_session_booking_product_name">{item.name}</div>
					<ProductDetails product={item} />
                </div>
            )
        })
    }

    return (
        <>
            <div className="title">{t.getTranslation('products.title', 'Sélectionnez un type de consultation proposée')}</div>
            <div className="widget_session_booking_products">
                {getItems()}
            </div>
            <div className="widget_session_booking_submit">
				{queryScope && (
					<button onClick={() => window.history.back()} className='widget_session_booking_back'>
						<i className="hgi-stroke hgi-arrow-left-02"></i>
						{t.getTranslation('products.back', 'Retour')}
					</button>
				)}
               <button className="btn btn-default btn-large" onClick={() => setProduct(selected)}>
					{t.getTranslation('products.submit', 'Choisir ce service')}
					<i className="hgi-stroke hgi-arrow-right-02"></i>
				</button>
            </div>
        </>
    )

}

export default Products